import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { queryKeys } from "@/lib/queryKeys";

/** Calls get-connect-status edge function to fetch Stripe account and update stripe_connect_accounts, then invalidates payout status. Use after onboarding return (e.g. ?return=1). */
export function useSyncPayoutStatus() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase.functions.invoke("get-connect-status", {});
      if (error) throw error;
      if (data?.error) throw new Error(data.error);
      return data as {
        account_id: string | null;
        onboarding_status: string;
        charges_enabled: boolean;
        payouts_enabled: boolean;
        details_submitted: boolean;
      };
    },
    onSuccess: () => {
      if (user?.id) {
        queryClient.invalidateQueries({ queryKey: queryKeys.user.payoutStatus(user.id) });
      }
    },
  });
}
